
import './App.scss';
import Header from './components/Header';
import Profile from './components/Profile';
import About from './components/About';
import Works from './components/Works';


function App() {

  
  return (
    <div className="App">
      
      <Header />
      <Profile />
      <About />
      <Works />
    
      
    </div>
  );
}

export default App;
